module.exports = __webpack_public_path__ + "static/index-d6a8eeec7117e33ce6bcbd1857451943.mp4";